import { Injectable, signal } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class SharedSignalsService {

  sessionTimer = signal(0)
  isLogin = signal(false);
  showTimeOutPopup = signal(false);
  textDirection = signal('ltr');
  showCancelOrderPopup = signal(false);
  showHeader = signal(true);
  showFooter = signal(true);
  headerType = signal('site')
  orderStatus = signal(null);
  darkHeader = signal(false);
  blueDarkHeader = signal(false);
  userAgentType = signal(null);
  userBrowserName = signal(null);
  showThankyouPopup = signal(false);
  showSignUpBanner = signal(true);
  isError = signal(false)
  constructor(private toasterService : MessageService) { }

  setUserAgentType(type:string){
    this.userAgentType.set(type);
  }

  setBrowserName(name:string){
    this.userBrowserName.set(name);
  }

  setDarkHeader(data: boolean){
    this.darkHeader.set(data)
  }
  setblueDarkHeader(data: boolean){
    this.blueDarkHeader.set(data)
  }

  setOrderStatus(status: string) {
    this.orderStatus.set(status);
  }

  setIsLogin( data : boolean){
    this.isLogin?.set(data);
  }
  
  setHeader(header: boolean) {
    this.showHeader.set(header);
  }

  setFooter(footer: boolean) {
    this.showFooter.set(footer);
  }

  setTextDirection( type : string){
    this.textDirection?.set(type);
  }

  setTimeOutPopup( data : boolean){
    this.showTimeOutPopup?.set(data);
  }

  setSessionTime( data : number){
    this.sessionTimer?.set(data);
  }

  setShowCancelOrderPopup( data : boolean){
    this.showCancelOrderPopup?.set(data);
  }
  setShowThankyouPopup( data : boolean){
    this.showThankyouPopup?.set(data);
  }
  setShowSignUp( data : boolean){
    this.showSignUpBanner?.set(data);
  }
  setErrorPopup(data:boolean){
    this.isError?.set(data)
  }



  showMessage(severityType:string, toastMessage:string){
    this.toasterService.clear();
    this.toasterService.add({  severity: severityType,  detail: toastMessage});
  }
}
